import { render, staticRenderFns } from "./SBPopup.html?vue&type=template&id=e4bcf064&scoped=true&"
import script from "./SBPopup.ts?vue&type=script&lang=ts&"
export * from "./SBPopup.ts?vue&type=script&lang=ts&"
import style0 from "./SBPopup.css?vue&type=style&index=0&id=e4bcf064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bcf064",
  null
  
)

export default component.exports